import styled from "@emotion/styled";

export const Label = styled.div`
  display: flex;
  align-items: center;
  color: #6d6d6d;
  font-family: Poppins Ligth;
  font-size: 0.9em; ;
`;
export const Input = styled.input`
  display: block;
  margin-right: 0.7em;
`;
